import { Box, Stack, Toolbar } from '@mui/material';
import ReadingViewHeader from './ReadingViewHeader';
import SidebarReaderMenu from './ReaderMenu/SidebarReaderMenu';
import MainContentArea from './MainContentArea';
import AnnotationDialogsProvider from '../features/Annotation/AnnotationDialogsContext';
import AnnotationEditDialog from '../features/Annotation/components/AnnotationEdit/Dialog';
import AnnotationDeleteDialog from '../features/Annotation/components/AnnotationDelete/Dialog';
import { BookMenuContextProvider } from './BookMenuContext';

export default function ReadingViewPage() {
  return (
    <BookMenuContextProvider>
      <AnnotationDialogsProvider>
        <ReadingViewHeader />
        {/* The hide-on-scroll handles the space under the fixed app
                header, making sure content doesn't clip under the header. */}
        <Toolbar />
        <Stack
          direction='row'
          justifyContent='space-between'
          id='reading-view-container'
          sx={{ height: '100%', flexGrow: 1 }}
        >
          <SidebarReaderMenu />
          <Box
            sx={{
              width: (theme) => ({
                xs: 0,
                lg: `calc(${theme.spacing(8)} + 1px)`,
                xl: 0,
              }),
            }}
          />

          <MainContentArea />
        </Stack>

        <AnnotationEditDialog />
        <AnnotationDeleteDialog />
      </AnnotationDialogsProvider>
    </BookMenuContextProvider>
  );
}
